import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
`;

export const TableContainer = styled.div`
	padding: 0.5% 0 0 0;
`;
export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 15% 0;
`;

export const Wrapper = styled.div`
	display: flex;
	height: 100%;
`;

export const TableWrapper = styled.div`
	width: 100%;
	overflow: hidden;

	.ag-theme-balham {
		width: 100%;
		height: 100%;
		font-family: 'Roboto';

		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
			border: none;
		}

		.ag-header-row {
			border-bottom: 0px;
		}

		.ag-header {
			background-color: transparent;
			border: none;
			color: ${colors.grey5};
		}

		.ag-header-cell {
			font-weight: normal;
			font-size: 11px;
			line-height: 13px;
			letter-spacing: 0.8px;
			padding-bottom: 5px;
			font-family: 'Roboto';

			.ag-header-cell-text {
				white-space: pre-line;
			}

			&.ag-numeric-header {
				text-align: right;
			}

			&::after {
				display: none;
			}
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};

			&.ag-row-last {
				border-bottom: none;
			}

			.ag-cell {
				font-size: 13px;
				font-weight: normal;
				line-height: 24px;
				letter-spacing: 0.3px;
				color: ${colors.grey5};
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
	}
`;

export const Heading = styled.div`
	font-size: 1.1rem;
	color: ${colors.grey600};
`;

export const AnalysisDescription = styled.div`
	font-size: 0.9rem;
	color: ${colors.grey500};
`;
